import { render } from "./PerfilPagos.vue?vue&type=template&id=52b628ab&lang=true"
import script from "./PerfilPagos.vue?vue&type=script&lang=ts"
export * from "./PerfilPagos.vue?vue&type=script&lang=ts"
script.render = render

export default script